import { Either } from "src/base/Either";
import { Failure } from "src/base/Failure";
import { NoParam } from "src/base/NoParam";
import { UseCase } from "src/base/UseCase";
import { ISubscriptionRepository } from "../../data/repositories/subscriptionRepository";
import { IPlan } from "../model/plan";

export class GetAllPlans extends UseCase<NoParam, IPlan[]> {
  private repository: ISubscriptionRepository;
  constructor(repository: ISubscriptionRepository) {
    super();
    this.repository = repository;
  }

  call(params: NoParam): Promise<Either<Failure, IPlan[]>> {
    return this.repository.getAllPlans();
  }
}
